import { useMemo } from 'react';
import { useSelector } from 'react-redux';

useAgency.propTypes = {};

function useAgency(props) {
  // MARK: ---- PROPERTIES ----
  const operatorList = useSelector((state) => state.app.appConfig.operators);

  return useMemo(() => {
    return {
      // nha dieu hanh
      operatorList,
      operatorOptions:
        operatorList?.map((item) => ({
          name: item.name,
          value: item.operatorId,
        })) ?? [],
    };
  }, [operatorList]);
}

export default useAgency;
